<template>
  <v-btn
    @click="$emit('click')"
    width="160"
    height="50"
    rounded="lg"
    class="download-btn"
  >
    <v-icon color="white" icon="mdi-cloud-arrow-down-outline"></v-icon>
    <span> {{ $t("downloadButtonWidget.buttonText") }} </span>
  </v-btn>
</template>

<script>
export default {
  emits: ["click"],
};
</script>

<style scoped lang="scss">
@media only screen and (max-width: 601px) {
  .download-btn {
    width: unset !important;
    height: 40px !important;
    font-size: 13px !important;
  }
}
.download-btn {
  background: #29c4d0;
  font-size: $smallTextSize;
  color: #ffffff;
  font-weight: 400;
}
</style>
